import { c as _c } from "react/compiler-runtime";
import { useEffect, useRef } from 'react';
import { WippenSupportSpringsDesignMode, type WippenSupportSpringsDesignTarget } from '@/lib/piano/touch-design/design/wippen-support-springs-design';
export const useWippenSupportSpringsRecommendation = (wippenSupportSpringsDesignMode, wippenSupportSpringsDesignTarget, setWippenSupportSpringsDesign) => {
  const $ = _c(5);
  const isFirstRender = useRef(true);
  let t0;
  let t1;
  if ($[0] !== setWippenSupportSpringsDesign || $[1] !== wippenSupportSpringsDesignMode || $[2] !== wippenSupportSpringsDesignTarget) {
    t0 = () => {
      if (isFirstRender.current) {
        if (wippenSupportSpringsDesignMode === null && wippenSupportSpringsDesignTarget === null) {
          setWippenSupportSpringsDesign(WippenSupportSpringsDesignMode.None, null);
        }
        isFirstRender.current = false;
      }
    };
    t1 = [isFirstRender, setWippenSupportSpringsDesign, wippenSupportSpringsDesignMode, wippenSupportSpringsDesignTarget];
    $[0] = setWippenSupportSpringsDesign;
    $[1] = wippenSupportSpringsDesignMode;
    $[2] = wippenSupportSpringsDesignTarget;
    $[3] = t0;
    $[4] = t1;
  } else {
    t0 = $[3];
    t1 = $[4];
  }
  useEffect(t0, t1);
};